/**
 * @file 字符串转换相关
 */

import { _system } from '@umu/ukit-lang';

/**
 * 根据字符个数截断字符串
 */
export function shortString(string: string = '', maxLength: number, offset: number = 0) {
    const length = string.length;
    // 英文环境长度加倍
    if (_system('EN')) {
        maxLength = maxLength * 2;
    }
    if (_system('EM')) {
        maxLength = maxLength * 2;
    }
    if (length <= maxLength) {
        return string;
    }

    string = string.substring(0, maxLength - offset) + '...';
    return string;
}

/**
 * @description 取文本真实长度
 * webkit内核识别\n长度为2，但js识别长度为1，导致未达到maxlength时就不可继续输入了
 * 在firefox无此问题
 * 在此补上换行的长度，提前识别不可输入的状态
 */
export function getFixBreakLength(val: string) {
    let ret = 0;
    // 空字符串
    if (val) {
        const inputLength = val.length;
        const valArr = val.split(/[\r\n|\n|\r]/);
        const brLength = valArr.length - 1;

        ret = inputLength;

        if (brLength > 0) {
            // 有回车
            ret += brLength;
        }
    }
    return ret;
}

/**
 * @description safetyHtml
 */
export function safetyHtml(html: string) {
    html = html.replace(/[\r\n]+/g, '\n');
    return html;
}

/**
 * @description unhtml
 */
export function unhtml(str: string, reg?: RegExp) {
    const map: { [key: string]: string } = {
        '<': '&lt;',
        '&': '&amp;',
        '"': '&quot;',
        '>': '&gt;',
        "'": '&#39;',
    };
    return str
        ? str.replace(reg || /[&<">'](?:(amp|lt|quot|gt|#39|nbsp|#\d+);)?/g, (a, b) => {
              if (b) {
                  return a;
              } else {
                  return map[a];
              }
          })
        : '';
}
